<label class="switch">
  <input type="checkbox" [formControl]="checkField" (click)="onSubmit()" />
  <span class="slider round"></span>
</label>
<label class="custom-text">{{ name }}</label>
